import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import './index.css';

const rootElement = document.getElementById('root');
const app = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.createRoot(rootElement).render(app);
